import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import http from '../Api/http';
import Util from '../Util';

const ContactUs = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [failedMessage, setFailedMessage] = useState("");
    const [formData, setFormData] = useState({
        Id: 0,
        InsDate: new Date(),
        Name: '',
        Email: '',
        Phone: '',
        Notes: '',
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: '' }));
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.Name) newErrors.Name = t('requiredField');
        if (!formData.Phone) newErrors.Phone = t('requiredField');
        if (!formData.Notes) newErrors.Notes = t('requiredField');
        if (formData) {
            if (formData.Phone) {
                if (!Util.checkPhone(formData.Phone, false)) {
                    newErrors.Phone = t('phoneError')
                }
            } if (formData.Email) {
                if (!Util.checkEmail(formData.Email)) {
                    newErrors.Email = t('emailError')
                }
            }
        }
        return newErrors;
    };

    const onSave = async (e) => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            setLoading(true);
            setSubmitted(true);
            
            const result = await http.postJsonAxios(http.actions.ContactUs.Save, formData,t);
            if (result.status === 200 && result.data.success) {
                setErrors({});
                setFormData({
                    Id: 0,
                    InsDate: new Date(),
                    Name: '',
                    Email: '',
                    Phone: '',
                    Notes: '',
                });
                setSuccessMessage(t('done'));
                setTimeout(() => setSuccessMessage(""), 3000); // إخفاء الرسالة بعد 3 ثواني

            } else {
                setFailedMessage(result.data.errorText || t('failed'));
                setTimeout(() => setFailedMessage(""), 3000);
            }
        }
        catch (e) {

        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-center flex flex-col">
            <div className="flex flex-col">
                <div className="w-full max-w-6xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-12">
                    {/* Title */}
                    <h2 className="text-3xl font-bold text-center mb-8 text-blue-600">
                        {t('contactUs')}
                    </h2>

                    {/* Info + Form Layout */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Contact Info */}
                        <div>
                            <h3 className="text-xl font-semibold mb-4 text-gray-800">{t('getInTouch')}</h3>
                            <p className="mb-4 text-gray-600">
                                {t('contactText')}
                            </p>
                            <ul className="space-y-2 text-gray-700">

                                <li><span dir={t('dir') === "rtl"}><strong>{t('phone')}: </strong><span dir="ltr">+972 59-984-4222</span></span></li>
                                <li><span dir={t('dir') === "rtl"}><strong>{t('phone')}: </strong><span dir="ltr">+972 50-544-5766</span></span></li>
                                <li><strong>{t('email')}: </strong> gm@abdobus.com</li>
                                <li><strong>{t('address')}: </strong>{t('addressText')}</li>
                            </ul>
                        </div>

                        {/* Contact Form */}
                        <form className="space-y-4 text-black">
                            {successMessage && (
                                <div className="bg-green-100 text-green-800 p-2 rounded mb-2 text-center border border-green-400">
                                    {successMessage}
                                </div>
                            )}
                            {failedMessage && (
                                <div className="bg-red-100 text-red-800 p-2 rounded mb-2 text-center border border-red-400">
                                    {failedMessage}
                                </div>
                            )}
                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('name')}</label>
                                <input
                                    name='Name'
                                    type="text"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    placeholder={t('yourName')}
                                    className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                                    required
                                    autoFocus
                                />
                                {errors.Name && (<p className="text-red-500 text-sm mt-1">{errors.Name}</p>)}
                            </div>

                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('phone')}</label>
                                <input
                                    name="Phone"
                                    type="text"
                                    value={formData.Phone}
                                    onChange={handleChange}
                                    required
                                    placeholder={t('yourPhone')}
                                    className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                                />
                                {errors.Phone && (<p className="text-red-500 text-sm mt-1">{errors.Phone}</p>)}
                            </div>

                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('email')}</label>
                                <input
                                    name="Email"
                                    type="email"
                                    value={formData.Email}
                                    onChange={handleChange}
                                    placeholder={t('yourEmail')}
                                    className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                                    required
                                />
                                {errors.Email && (<p className="text-red-500 text-sm mt-1">{errors.Email}</p>)}
                            </div>

                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('yourMessage')}</label>
                                <textarea
                                    name="Notes"
                                    value={formData.Notes}
                                    onChange={handleChange}
                                    placeholder={t('yourMessage')}
                                    className="w-full border border-gray-300 p-2 rounded h-32 resize-none focus:ring-2 focus:ring-blue-500 outline-none"
                                    required
                                />
                                {errors.Notes && (<p className="text-red-500 text-sm mt-1">{errors.Notes}</p>)}
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setSubmitted(true);
                                    onSave();
                                }}
                                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 outline-none"
                            >
                                {t('sendMessage')}
                            </button>
                        </form>
                    </div>

                    {/* Optional Map */}
                    {/* <div className="mt-10">
                        <iframe
                            title="Company Location"
                            className="w-full h-58 rounded-md"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3389.5352326329843!2d35.26075261513524!3d32.22111361913714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151cdd5d38aab447%3A0x7d84cb9924e70e37!2z2KfZhNmF2YjYp9izINin2YTYqNin2YXYp9ix2Kk!5e0!3m2!1sen!2s!4v1629725010880!5m2!1sen!2s"
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
